import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  ID,
  Name,
  Type,
  MembershipType,
  ObjectSid,
  ObjectClass,
  Owners,
  UserMembers,
  Groups,
  LastUpdatedAt,
  DescriptionWith1ColSpan,
  CreatedAt,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AzureADGroupMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;

  return (
    <Grid templateColumns="repeat(3, 1fr)" gap={4}>
      {Name(insight)}
      {DescriptionWith1ColSpan(resource)}
      {ID(insight)}
      {Type(resource)}
      {MembershipType(resource)}
      {ObjectSid(resource)}
      {ObjectClass(resource)}
      {Owners(resource)}
      {UserMembers(resource)}
      {Groups(resource)}
      {CreatedAt(resource, 'utc')}
      {LastUpdatedAt(resource)}
    </Grid>
  );
};
